import moment from 'moment'
import { dialogFlowIntentNames, goodDialogFromIntents } from 'features/Engagement/constants'

import styles from './DailyConversations.module.scss'

function getShortDate(date) {
  return date.toISOString().split('T')[0]
}

const ConversationList = ({
  groupedConversationsByHotel,
  activeChatId,
  onChatRowClick,
  reviewedConversations,
  flaggedConversations,
  date
}) => {
  return (
    <>
      {groupedConversationsByHotel.map(({ hotelName, conversations: hotelConversations }) => (
        <div key={hotelName} className={styles.hotelGroup}>
          <div className={styles.hotelGroupHeader}>
            <span className={styles.hotelGroupTitle}>{hotelName}</span>
            <span className={styles.hotelGroupCount}>
              {hotelConversations.length}{' '}
              {hotelConversations.length === 1 ? 'conversation' : 'conversations'}
            </span>
          </div>
          <div className={styles.hotelGroupContent}>
            {hotelConversations.map(c => {
              const messageCount = c.messages?.length || 0
              const lastMessage = c.messages?.[c.messages.length - 1]
              const lastMessageTime = lastMessage
                ? lastMessage.finalizedOn || lastMessage.sentOn || lastMessage.scheduledOn
                : null
              const lastMessageContent = lastMessage?.content || ''
              const lastMessageBotIntent = lastMessage?.botIntent
              const hasGoodIntent =
                lastMessageBotIntent && goodDialogFromIntents.includes(lastMessageBotIntent)

              return (
                <div
                  key={c.chatId}
                  onClick={() => onChatRowClick(c.chatId)}
                  className={[
                    styles.chatRow,
                    c.chatId === activeChatId ? styles.chatRowActive : ''
                  ].join(' ')}
                  style={{
                    opacity: reviewedConversations?.[getShortDate(date)]?.[c.chatId] ? 0.5 : 1,
                    background: flaggedConversations?.[getShortDate(date)]?.[c.chatId]
                      ? 'rgba(33, 150, 243, 0.2)'
                      : 'white'
                  }}
                >
                  {messageCount > 1 && (
                    <div className={styles.countBubble}>
                      {messageCount > 9 ? '9+' : messageCount}
                    </div>
                  )}
                  <div className={styles.rowLeft}>
                    <div className={styles.username}>
                      {flaggedConversations?.[getShortDate(date)]?.[c.chatId] ? (
                        <span className={styles.flag}>&#9872;</span>
                      ) : null}
                      {lastMessageTime && (
                        <span className={styles.messageTime}>
                          {moment(lastMessageTime).format('h:mm A')}
                        </span>
                      )}
                    </div>
                    <div className={styles.preview}>
                      {hasGoodIntent && (
                        <span className={styles.intentBadge}>
                          {dialogFlowIntentNames[lastMessageBotIntent]}
                        </span>
                      )}
                      <span className={styles.lastMessage}>
                        {lastMessageContent || c.botContext || 'No messages'}
                      </span>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </>
  )
}

export default ConversationList

